import React from 'react';
import './styles.css';
import { FormContainer, FormRowView, TableView } from 'components/shared';
import MobileTableAccordionView, { MobileTableAccordionDataItem, MobileTableAccordionToggle } from 'components/shared/views/MobileTableAccordionView';
import { CustomAccordionClose, CustomAccordionContent, useCustomAccordion } from "components/custom-ui/CustomAccordion";
import { SVGAsset } from 'res';
import { Link, DisabledPrompt } from "bcms-react";

/**
 * @function MobileUnlinkedAccountsTable
 * @return {React.Component}
 * @exported true
 * @description A table for unlinked accounts.
 */

export default function MobileUnlinkedAccountsTable(props) {
  const accounts = props.accounts ?? [];
  const rows = accounts.reduce((acc, account) => {
    acc.push(
      <MobileUnlinkedAccountsView key={ account.id } account={ account }/>
    );
    return acc;
  }, []);
  
  return(
    <div className="mobile-unlinked-accounts-table">
        { rows }
    </div>
  );
}

/**
 * @function MobileUnlinkedAccountsView
 * @return {React.Component}
 * @exported false
 * @description A view that contains a toggle and content
 * (row) for an account which is repeated over.
 */

function MobileUnlinkedAccountsView(props) {
  const account = props.account ?? {};

  return (
    <MobileTableAccordionView key={ account.id }>
        <MobileUnlinkedAccountsToggle account={ account } />
        <MobileUnlinkedAccountsContent account={ account } />
      </MobileTableAccordionView>
  )
}

/**
 * @function MobileUnlinkedAccountsToggle
 * @return {React.Component}
 * @exported false
 * @description The Table row that is clicked and show/hides the MobileUnlinkedAccountsContent.
 */

function MobileUnlinkedAccountsToggle(props){
  const { state } = useCustomAccordion();
  const account = props.account ?? [];

  return(
    <MobileTableAccordionToggle icon={ state ? "DownChevronIcon" : "RightChevronIcon" } rightValue="">
      <MobileTableAccordionDataItem columnHeader="" data={ account.name } />
    </MobileTableAccordionToggle>
  );
}

/**
 * @function MobileUnlinkedAccountsContent
 * @return {React.Component}
 * @exported false
 * @description The dropdown content for the MobileUnlinkedAccountsTable.
 */

function MobileUnlinkedAccountsContent(props) {
  const account = props.account ?? [];

  return(
    <CustomAccordionContent>
        <div className="custom-accordion-content-container">
          <div className="flex-container custom-accordion-header">
            <p className="flex-width">ACCOUNT DETAILS</p>

            <CustomAccordionClose className="set-width clickable">
              <SVGAsset id="CloseX" className="icon" />
            </CustomAccordionClose>
          </div>

          <FormContainer>
            <FormRowView text="Account Owner" className="light-text">
              <p><b>{ account.accountOwner }</b></p>
            </FormRowView>

            <FormRowView text="Account Owner Type" className="light-text account-owner-type-detail">
              <p><b>{ account.accountOwnerType }</b></p>
            </FormRowView>

            <FormRowView text="Account Number" className="light-text">
              <p><b>{ account.number }</b></p>
            </FormRowView>

            <FormRowView text="Date Added" className="light-text">
              <p><b>{ account.dateOpened.format("m/d/Y") }</b></p>
            </FormRowView>

            <FormRowView className="light-text">
              <DisabledPrompt>
                <Link>Edit Account</Link>
              </DisabledPrompt>
            </FormRowView>

            <FormRowView className="light-text">
              <DisabledPrompt>
                <Link>Remove Account</Link>
              </DisabledPrompt>
            </FormRowView>
          </FormContainer>
        </div>
      </CustomAccordionContent>
  );
}